export default __webpack_public_path__ + "static/media/1-min.676a5c07.jpg";